export enum ChatAgentRoles {
  USER = 'roles.chatAgentUser',
  GRAPHQL_MCP_USER = 'roles.chatAgentGraphQLMCPUser',
}
